import React, { ReactElement } from 'react';
import AppLayout from 'components/layouts/AppLayout';
import { H2 } from 'components/typography';
import A from 'components/layouts/A';
import { getRoute } from 'constants/routes';
import { ForgottenPasswordState } from 'components/login/forgotten_password/ForgottenPasswordBlock';
import { getTranslation, useTranslation } from 'utils/localization';
import { TNamespaceEnum } from 'types/types';
import { RecoveryType } from 'components/personRecovery/PersonRecoveryPage';

const RenewMembershipPage = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <AppLayout
            pageTitle={{
                primaryBoldText: getTranslation(
                    t,
                    TNamespaceEnum.renewMembership,
                    'pageTitle'
                ),
                isDark: true,
            }}
        >
            <>
                {/*Login and password is known*/}
                <div>
                    <H2>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'loginPasswordKnownTitle'
                        )}
                    </H2>
                    <p>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'loginPasswordKnownText'
                        )}{' '}
                        <A href={getRoute('/')}>
                            {getTranslation(
                                t,
                                TNamespaceEnum.renewMembership,
                                'here'
                            )}
                        </A>
                    </p>
                </div>
                {/*Login known, password is unknown*/}
                <div>
                    <H2>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'loginKnownPasswordUnknownTitle'
                        )}
                    </H2>
                    <p>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'loginKnownPasswordUnknownText'
                        )}{' '}
                        <A
                            href={getRoute('/', [], undefined, {
                                resetPassword: ForgottenPasswordState.SHOW,
                            })}
                        >
                            {getTranslation(
                                t,
                                TNamespaceEnum.renewMembership,
                                'here'
                            )}
                        </A>
                    </p>
                </div>
                {/*Login and password is unknown*/}
                <div>
                    <H2>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'loginPasswordUnknownTitle'
                        )}
                    </H2>
                    <p>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'loginPasswordUnknownText'
                        )}{' '}
                        <A
                            href={getRoute('/person-recovery', [], undefined, {
                                recoveryType: RecoveryType.WithoutEmail,
                            })}
                        >
                            {getTranslation(
                                t,
                                TNamespaceEnum.renewMembership,
                                'here'
                            )}
                        </A>
                    </p>
                </div>
                {/*Never logged in*/}
                <div>
                    <H2>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'neverLoggedInTitle'
                        )}
                    </H2>
                    <p>
                        {getTranslation(
                            t,
                            TNamespaceEnum.renewMembership,
                            'neverLoggedInText'
                        )}{' '}
                        <A href={getRoute('/person-recovery')}>
                            {getTranslation(
                                t,
                                TNamespaceEnum.renewMembership,
                                'here'
                            )}
                        </A>
                    </p>
                </div>
            </>
        </AppLayout>
    );
};

export default RenewMembershipPage;
